import React, { useEffect, useRef } from 'react';
// import '../styles/EndUserComputingSection.css';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css'
import synectiksImage from './../../../../assets/company/careers/forall.png'; // replace with your actual image path

const SynectiksForAllSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    [textRef.current, imageRef.current].forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);


  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-image" ref={imageRef}>
          <img src={synectiksImage} alt="Team at Synectiks" />
        </div>
        <div className="end-user-text" ref={textRef}>
          <h2>SYNECTIKS for All!</h2>
          <p>
            SYNECTIKS is proud to be an equal opportunity workplace. We take great care to evaluate all employees and job applicants equally, based on competence and qualifications. We will not discriminate by age, race, gender, color, religion, national origin, sexual orientation, veteran status, marital status, disability status, or any other protected category. For assistance or reasonable accommodation during the interview process, please contact us by sending an e-mail to <a href="mailto:hr@synectiks.com">hr@synectiks.com</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SynectiksForAllSection;
